
























































































































import { Component, Vue } from 'vue-property-decorator';
import { Prop } from 'vue-property-decorator';
import moment from 'moment';
import 'moment/locale/de';
import { Address } from '../interfaces/addresses';

@Component({
})
export default class AddressList extends Vue {
  @Prop({ default: [] }) readonly addresses!: Address[];

  formatChangedDate(tstamp: number) {
    return moment.unix(tstamp).format('DD.MM.YYYY');
  }

  changedDate(address: Address) {
    if (address.crdate === address.tstamp) {
      return '';
    }

    return this.formatChangedDate(address.tstamp);
  }
}
